<script setup lang="ts">
import { IMAGE_BASE_URL } from '~/constants/image.constant'

const route = useRoute()

const imgSrc = computed(() => {
  const path = route.path.split('/')[1] as string
  //if (path === 'blocks') {
  //  return `${IMAGE_BASE_URL}/character/main/main_block.png`
  // }
  if (path === 'transactions') {
    return `${IMAGE_BASE_URL}/main/main_transaction.png`
  }
  if (path === 'accounts') {
    return `${IMAGE_BASE_URL}/character/main/main_account.png`
  }
  return ''
})
</script>

<template>
  <img
    v-if="imgSrc"
    :src="imgSrc"
    alt=""
    width="368"
    class="background"
  >
</template>

<style scoped lang="scss">
.background {
  @apply fixed left-0;
  bottom: env(safe-area-inset-bottom, 0px);

  @include lg {
    @apply hidden;
  }
}
</style>